import React, { useContext } from 'react';
import { ToastContext } from './types';

export const toastContext = React.createContext<ToastContext>({
    toastContainerRef: { current: null },
    setToastContainerRef: () => {},
});
export const useToastContext = () => useContext(toastContext);
